import { useEffect, useState } from 'react';
import api from '../api';

export default function Integrations() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [status, setStatus] = useState({ twitch: { connected: false }, youtube: { connected: false }, tiktok: { connected: false }, instagram: { connected: false } });
  const [notice, setNotice] = useState('');
  const [debugData, setDebugData] = useState(null);
  const currentBase = (import.meta.env.VITE_API_URL || 'http://localhost:5000').replace(/\/$/, '');

  async function loadStatus() {
    setLoading(true); setError('');
    try {
      const { data } = await api.get('/integrations/status');
      setStatus(data || { twitch: { connected: false } });
    } catch (e) {
      setError('Konnte Integrationsstatus nicht laden');
    } finally { setLoading(false); }
  }

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const provider = params.get('provider');
  if ((provider === 'twitch' || provider === 'youtube' || provider === 'tiktok' || provider === 'instagram') && params.get('status') === 'success') {
      // Clean URL then reload status
      const url = new URL(window.location.href);
      url.search = '';
      window.history.replaceState({}, '', url.toString());
      // Give backend a brief moment, then reload status
      setTimeout(() => { loadStatus(); }, 250);
      return;
    }
    if (params.get('oauth_error')) {
      const err = params.get('oauth_error');
      const desc = params.get('oauth_error_description');
      setNotice(`OAuth Fehler (${err}): ${desc || ''}`);
    }
    loadStatus();
  }, []);

  const connectTwitch = async () => {
    try {
      window.location.href = `${currentBase}/integrations/twitch/start`;
    } catch {}
  };

  const disconnectTwitch = async () => {
    try {
      await api.post('/integrations/twitch/disconnect');
      await loadStatus();
    } catch {
      setError('Trennen fehlgeschlagen');
    }
  };

  const connectYouTube = async () => {
    try {
      window.location.href = `${currentBase}/integrations/youtube/start`;
    } catch {}
  };

  const disconnectYouTube = async () => {
    try {
      await api.post('/integrations/youtube/disconnect');
      await loadStatus();
    } catch {
      setError('Trennen fehlgeschlagen');
    }
  };

  const connectTikTok = async () => {
    try {
      window.location.href = `${currentBase}/integrations/tiktok/start`;
    } catch {}
  };

  const disconnectTikTok = async () => {
    try {
      await api.post('/integrations/tiktok/disconnect');
      await loadStatus();
    } catch {
      setError('Trennen fehlgeschlagen');
    }
  };

  const connectInstagram = async () => {
    try {
      window.location.href = `${currentBase}/integrations/instagram/start`;
    } catch {}
  };

  const disconnectInstagram = async () => {
    try {
      await api.post('/integrations/instagram/disconnect');
      await loadStatus();
    } catch {
      setError('Trennen fehlgeschlagen');
    }
  };

  const loadDebug = async () => {
    try {
      const { data } = await api.get('/integrations/debug');
      setDebugData(data);
    } catch {
      setDebugData({ error: 'Debug nicht verfügbar' });
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ marginTop: 0 }}>Kanal-Verknüpfungen</h2>
      <p>Verbinde deine Kanäle, um erweiterte Statistiken und Funktionen freizuschalten.</p>
      {notice && (
        <div style={{ background:'rgba(239, 68, 68, 0.12)', border:'1px solid rgba(239,68,68,0.4)', color:'#ef4444', padding:12, borderRadius:8, marginBottom:12 }}>
          {notice}
        </div>
      )}
      {loading && <p>Lade…</p>}
      {error && <p style={{ color: 'crimson' }}>{error}</p>}

      {/* Twitch Card */}
      <div style={{ display: 'flex', gap: 16, alignItems: 'center', padding: 16, border: '1px solid #e5e7eb', borderRadius: 8, marginTop: 12 }}>
        <div style={{ width: 32, height: 32, borderRadius: 6, background: '#9146FF', color: 'white', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700 }}>TW</div>
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 600 }}>Twitch</div>
          <div style={{ color: '#6b7280' }}>
            {status.twitch?.connected
              ? <>Verbunden als <b>{status.twitch.display_name || status.twitch.login}</b></>
              : <>Nicht verbunden</>}
          </div>
          {status.twitch?.connected && (
            <div style={{ marginTop: 6, fontSize: 13, color: '#6b7280' }}>
              Scopes: {(status.twitch.scopes || []).join(', ') || '–'}
            </div>
          )}
        </div>
        {status.twitch?.connected ? (
          <button onClick={disconnectTwitch} className="apn-btn" style={{ background: '#ef4444', color: 'white' }}>Trennen</button>
        ) : (
          <button onClick={connectTwitch} className="apn-btn" style={{ background: '#9146FF', color: 'white' }}>Verbinden</button>
        )}
      </div>

      {/* YouTube Card */}
      <div style={{ display: 'flex', gap: 16, alignItems: 'center', padding: 16, border: '1px solid #e5e7eb', borderRadius: 8, marginTop: 12 }}>
        <div style={{ width: 32, height: 32, borderRadius: 6, background: '#FF0000', color: 'white', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700 }}>YT</div>
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 600 }}>YouTube</div>
          <div style={{ color: '#6b7280' }}>
            {status.youtube?.connected
              ? <>Verbunden{status.youtube.title ? <> mit <b>{status.youtube.title}</b></> : null}</>
              : <>Nicht verbunden</>}
          </div>
          {status.youtube?.connected && (
            <div style={{ marginTop: 6, fontSize: 13, color: '#6b7280' }}>
              Scopes: {(status.youtube.scopes || []).join(', ') || '–'}
            </div>
          )}
        </div>
        {status.youtube?.connected ? (
          <button onClick={disconnectYouTube} className="apn-btn" style={{ background: '#ef4444', color: 'white' }}>Trennen</button>
        ) : (
          <button onClick={connectYouTube} className="apn-btn" style={{ background: '#FF0000', color: 'white' }}>Verbinden</button>
        )}
      </div>

      {/* Platz für weitere Plattformen (TikTok, Instagram) */}
      {/* TikTok Card */}
      <div style={{ display: 'flex', gap: 16, alignItems: 'center', padding: 16, border: '1px solid #e5e7eb', borderRadius: 8, marginTop: 12 }}>
        <div style={{ width: 32, height: 32, borderRadius: 6, background: '#0a0a0a', color: '#25F4EE', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700 }}>TT</div>
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 600 }}>TikTok</div>
          <div style={{ color: '#6b7280' }}>
            {status.tiktok?.connected
              ? <>Verbunden{status.tiktok.display_name ? <> als <b>{status.tiktok.display_name}</b></> : null}</>
              : <>Nicht verbunden</>}
          </div>
          {status.tiktok?.connected && (
            <div style={{ marginTop: 6, fontSize: 13, color: '#6b7280' }}>
              Scopes: {(status.tiktok.scopes || []).join(', ') || '–'}
            </div>
          )}
        </div>
        {status.tiktok?.connected ? (
          <button onClick={disconnectTikTok} className="apn-btn" style={{ background: '#ef4444', color: 'white' }}>Trennen</button>
        ) : (
          <button onClick={connectTikTok} className="apn-btn" style={{ background: '#25F4EE', color: '#0a0a0a' }}>Verbinden</button>
        )}
      </div>

      {/* Instagram Card */}
      <div style={{ display: 'flex', gap: 16, alignItems: 'center', padding: 16, border: '1px solid #e5e7eb', borderRadius: 8, marginTop: 12 }}>
        <div style={{ width: 32, height: 32, borderRadius: 6, background: 'linear-gradient(45deg, #F58529, #DD2A7B, #8134AF, #515BD4)', color: 'white', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700 }}>IG</div>
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 600 }}>Instagram</div>
          <div style={{ color: '#6b7280' }}>
            {status.instagram?.connected
              ? <>Verbunden{status.instagram.username ? <> als <b>@{status.instagram.username}</b></> : null}</>
              : <>Nicht verbunden</>}
          </div>
        </div>
        {status.instagram?.connected ? (
          <button onClick={disconnectInstagram} className="apn-btn" style={{ background: '#ef4444', color: 'white' }}>Trennen</button>
        ) : (
          <button onClick={connectInstagram} className="apn-btn" style={{ background: '#DD2A7B', color: 'white' }}>Verbinden</button>
        )}
      </div>

      <div style={{ marginTop: 18, fontSize: 13, color: '#9aa3b2' }}>
  <div style={{ fontWeight: 700, color: '#cbd5e1', marginBottom: 6 }}>Hinweis zur Twitch–Einrichtung</div>
        <ul style={{ paddingLeft: 18, margin: 0, lineHeight: 1.5 }}>
          <li>In der Twitch Developer Console muss die Redirect‑URL exakt eingetragen sein: <code style={{ background:'#111827', padding:'1px 4px', borderRadius:4 }}>{`${currentBase}/integrations/twitch/callback`}</code> (für lokale Entwicklung).</li>
          <li>Für produktive Umgebungen mit HTTPS entsprechend die Backend‑URL verwenden, z. B. <code style={{ background:'#111827', padding:'1px 4px', borderRadius:4 }}>https://dein-backend.example.com/integrations/twitch/callback</code>.</li>
          <li>Im Backend sollten <code style={{ background:'#111827', padding:'1px 4px', borderRadius:4 }}>TWITCH_CLIENT_ID</code> und <code style={{ background:'#111827', padding:'1px 4px', borderRadius:4 }}>TWITCH_CLIENT_SECRET</code> gesetzt sein. Optional <code style={{ background:'#111827', padding:'1px 4px', borderRadius:4 }}>FRONTEND_URL</code>, damit nach Erfolg zurück auf das Frontend umgeleitet wird.</li>
        </ul>
      </div>

      <div style={{ marginTop: 18, fontSize: 13, color: '#9aa3b2' }}>
        <div style={{ fontWeight: 700, color: '#cbd5e1', marginBottom: 6 }}>Hinweis zur YouTube–Einrichtung</div>
        <ul style={{ paddingLeft: 18, margin: 0, lineHeight: 1.5 }}>
          <li>In der Google Cloud Console muss die OAuth 2.0–Client–ID eingerichtet sein sowie die Redirect–URL: <code style={{ background:'#111827', padding:'1px 4px', borderRadius:4 }}>{`${currentBase}/integrations/youtube/callback`}</code>.</li>
          <li>Benötigte Scopes: <code style={{ background:'#111827', padding:'1px 4px', borderRadius:4 }}>youtube.readonly</code> und <code style={{ background:'#111827', padding:'1px 4px', borderRadius:4 }}>yt-analytics.readonly</code>.</li>
          <li>Um nach Erfolg zurück zum Frontend zu leiten, kann <code style={{ background:'#111827', padding:'1px 4px', borderRadius:4 }}>FRONTEND_URL</code> (oder <code style={{ background:'#111827', padding:'1px 4px', borderRadius:4 }}>CORS_ORIGIN</code>) gesetzt werden.</li>
        </ul>
      </div>

      <div style={{ marginTop: 18, fontSize: 13, color: '#9aa3b2' }}>
        <div style={{ fontWeight: 700, color: '#cbd5e1', marginBottom: 6 }}>Hinweis zur Instagram–Einrichtung</div>
        <ul style={{ paddingLeft: 18, margin: 0, lineHeight: 1.5 }}>
          <li>In den Meta App‑Einstellungen die Redirect‑URL eintragen: <code style={{ background:'#111827', padding:'1px 4px', borderRadius:4 }}>{`${currentBase}/integrations/instagram/callback`}</code>.</li>
          <li>Benötigte Scopes: <code style={{ background:'#111827', padding:'1px 4px', borderRadius:4 }}>instagram_basic</code>, <code style={{ background:'#111827', padding:'1px 4px', borderRadius:4 }}>pages_show_list</code>, <code style={{ background:'#111827', padding:'1px 4px', borderRadius:4 }}>pages_read_engagement</code>, <code style={{ background:'#111827', padding:'1px 4px', borderRadius:4 }}>instagram_manage_insights</code>.</li>
          <li>Es muss eine Facebook‑Seite mit einem Instagram‑Business/Creator‑Konto verknüpft sein, damit Analytics und Media verfügbar sind.</li>
        </ul>
      </div>

      <div style={{ marginTop: 10 }}>
        <button onClick={loadDebug} className="apn-btn" style={{ padding: '6px 10px' }}>Debug anzeigen</button>
        {debugData && (
          <pre style={{ marginTop: 8, background:'#0b1020', color:'#e5e7eb', padding: 10, borderRadius: 8, maxWidth: '100%', overflow:'auto' }}>{JSON.stringify(debugData, null, 2)}</pre>
        )}
      </div>
    </div>
  );
}
